import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.control-object-summary-card-representative {
	border-top: 1px solid ${dt('controlObjectSummaryCard.representative.borderColor')};
}
`;
